import Cookies from 'js-cookie'
import { useEffect, useState } from 'react'

// authToken === undefined means code has not started to 'look for' authToken yet
// this can come in very handy when we need to know this information

// authToken === null means that code has 'looked up for' authToken
// and no auth token was found.

export default function useGetAuthToken() {
  const [token, setToken] = useState<string | undefined | null>(undefined)

  useEffect(() => {
    const tokenFromCookie = Cookies.get('token')

    if (tokenFromCookie) {
      setToken(tokenFromCookie)
    } else {
      setToken(null)
    }
  }, [])

  return token
}
